import useTranslations from '../../../../hooks/useTranslations'
import ANTDButton from '../../../../shared/antd/ANTDButton'
import ANTDDivider from '../../../../shared/antd/ANTDDivider'
import ANTDInput from '../../../../shared/antd/ANTDInput'
import ANTDSelect from '../../../../shared/antd/ANTDSelect'
import ANTDSpin from '../../../../shared/antd/ANTDSpin'
import PopUpConfirm from '../../../../shared/PopUpConfirm'
import { EditOutlined } from '../../../../utils/icons'
import { ternary } from '../../../../utils/javascript'
import errorCodeField from '../../container/errorCodeField.container'

const ErrorCodeField = () => {
  const { t } = useTranslations()
  const {
    value,
    search,
    loading,
    isOpen,
    isEdit,
    options,
    isCustom,
    popConfirm,
    addNewDisabled,
    onScroll,
    onClosePopup,
    onInputChange,
    handleOnChange,
    handleAddNewItem,
    addSelectedOption,
    onDropdownVisible,
    handleEditClick,
  } = errorCodeField()
  const { list, loader } = { ...options }

  return (
    <>
      <ANTDSelect
        open={isOpen}
        filterOption={false}
        value={value}
        options={addSelectedOption(list)}
        onChange={(val, option) =>
          handleOnChange({ value: val, option, showConfirm: !!value })
        }
        onPopupScroll={onScroll}
        onDropdownVisibleChange={onDropdownVisible}
        optionRender={option => (
          <div className="d-flex space-between">
            {option?.label}
            {isCustom && (
              <EditOutlined onClick={e => handleEditClick(e, option)} />
            )}
          </div>
        )}
        dropdownRender={menu => (
          <>
            <div
              style={{
                padding: '5px 4px',
              }}
              className="d-flex"
            >
              <ANTDInput
                style={{ marginRight: '8px' }}
                value={search}
                onChange={onInputChange}
                onKeyDown={e => e.stopPropagation()}
                // disabled={!isEdit && addNewDisabled}
                placeHolder={t('job_SearchErrorCode')}
              />

              <ANTDButton
                type="primary"
                loading={loading}
                disabled={!isEdit && addNewDisabled}
                onClick={handleAddNewItem}
              >
                {ternary(isEdit, t('btn_Edit'), `${t('btn_Add')} +`)}
              </ANTDButton>
            </div>
            <ANTDDivider
              style={{
                margin: '8px 0',
              }}
            />
            {menu}
            {loader && <ANTDSpin size="small" style={{ paddingLeft: 10 }} />}
          </>
        )}
      />
      <PopUpConfirm
        isOpen={popConfirm?.open}
        onCancelModel={onClosePopup}
        description={t('msg_AreYouSureWantToChangeSelection')}
        onAccept={() => {
          handleOnChange({ showConfirm: false, ...popConfirm?.tempSelected })
          onClosePopup()
        }}
        onReject={onClosePopup}
      />
    </>
  )
}

export default ErrorCodeField
